import getReliabilityStats, { ReliabilityStats } from "../../../domain/use_cases/leedflow/overview/getReliabilityStats";
import { useContext, useEffect, useState } from "react"
import { ContextStatus } from "@leedpulse-monorepo/enums";
import { Dayjs } from "dayjs";
import AuthenticationContext from "../../contexts/auth/AuthenticationContext";

export const useLeedflowReliabilityStats = (
    period?: [Dayjs | null, Dayjs | null],
    subscriptionIds?: string[],
    exclude?: string[],
) => {
    const authContext = useContext(AuthenticationContext);
    const auth = authContext.authentication;
    const [stats, setStats] = useState<ReliabilityStats>({
        push: {
            legs: { sent: 0, failed: 0, excluded: 0, byError: {} },
            legacyCalls: { total: 0, failed: 0, byError: {} },
        },
        pushDispatchLatencyMs: { p50: null, p90: null },
        answerLatencyMs: { p50: null, p90: null },
        voicemailReasons: {},
        recordingPhases: {},
        resolutionStatus: {},
        faulty: { total: 0, byReason: {} },
    });
    const [status, setStatus] = useState<ContextStatus>(ContextStatus.IDLE);

    // Load reliability stats (with period filter)
    useEffect(() => {
        if (!auth) return;
        (async () => {
            setStatus(ContextStatus.LOADING);
            try {
                const res = await getReliabilityStats(auth, period, subscriptionIds, exclude);
                setStats(res);
                setStatus(ContextStatus.SUCCESS);
            } catch (error) {
                console.error(error);
                setStatus(ContextStatus.ERROR);
            }
        })();
    }, [auth, period, subscriptionIds, exclude]);

    return {
        stats,
        status,
    }
}
